import { useSelector } from 'react-redux';

import { IAuthStoreState } from 'common/redux/auth/reducer';
import { getAuth } from 'common/redux/auth/selectors';
import { IReduxState } from 'common/redux/createStore';

const useAuthUser = () => useSelector<IReduxState, IAuthStoreState>(getAuth);

export default useAuthUser;
